import styled from "styled-components";
import DropdownList from "./DropdownList";

interface IDropdown {
  dropdownSelected: string;
  dropdownIsOpen: boolean;
  setDropdownIsOpen: Function;
  choices: { label: string; icon: any | undefined }[];
  onclick: Function;
  css?: any;
}
const Dropdown = ({
  dropdownSelected,
  dropdownIsOpen,
  setDropdownIsOpen,
  choices,
  onclick,
  css,
}: IDropdown) => {
  return (
    <SContainer onClick={() => setDropdownIsOpen(!dropdownIsOpen)} style={css}>
      <SDropdown>{dropdownSelected}</SDropdown>
      <DropdownList
        setDropdownIsOpen={setDropdownIsOpen}
        dropdownIsOpen={dropdownIsOpen}
        choices={choices}
        dropdownSelected={dropdownSelected}
        onclick={onclick}
      />
    </SContainer>
  );
};
export default Dropdown;
const SContainer = styled.div`
  height: 100%;
  min-height: 40px;
  width: 100%;
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  padding: 0 16px;
  position: relative;
  cursor: pointer;
  transition:
    border-color var(--transition),
    box-shadow var(--transition);
  &:hover {
    border-color: var(--color-primary);
  }
`;
const SDropdown = styled.div`
  color: var(--color-primary);
  font-weight: 500;
  font-size: 14px;
`;
